

























































import { Component, Vue } from "vue-property-decorator";
import CButton from "@/basics/buttons/CButton.vue";
import CModal from "@/basics/modal/CModal.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";
import NoData from "@/basics/boxes/NoData.vue";
import NoteBox from "@/basics/boxes/NoteBox.vue";
import SimpleAlert from "@/basics/alerts/SimpleAlert.vue";
import { ROOM_ONE, RoomData, RoomVariables } from "@/graphql/query/room/one";
import { freeRoom } from "@/graphql/mutation/freeRoom";
import { rentRoom } from "@/graphql/mutation/rentRoom";
import LoadSpinner from "@/basics/icon/LoadSpinner.vue";

@Component({
  components: {
    CButton,
    CModal,
    ModalTitle,
    NoteBox,NoData,
    SimpleAlert,
    LoadSpinner
  },
  apollo: {
    room: {
      query: ROOM_ONE,
      variables(): RoomVariables {
        const params = this.$apollo.vm.$route.params;
        return {
          roomId: params.roomId as string
        };
      }
    }
  }
})
export default class ChangeStatus extends Vue {
  room: RoomData | null = null;

  showFreeModal = false;
  showRentModal = false;

  processing = false;

  get mode(): "free" | "rented" {
    return this.room!.mode;
  }

  get roomId(): string {
    return this.$route.params.roomId;
  }

  async free() {
    //
    try {
      this.processing = true;
      await freeRoom(this.$apollo, { roomId: this.roomId });
      alert('成功しました');
      location.reload();
    } catch (e) {
      alert(e.message);
    } finally {
      this.processing = false;
    }
  }

  async rent() {
    try {
      this.processing = true;
      await rentRoom(this.$apollo, { roomId: this.roomId });
      alert('成功しました');
      location.reload();
    } catch (e) {
      alert(e.message);
    } finally {
      this.processing = false;
    }
  }
}
